import { render, staticRenderFns } from "./ReleaseIdsPicker.vue?vue&type=template&id=a53e3dc4&"
import script from "./ReleaseIdsPicker.vue?vue&type=script&lang=js&"
export * from "./ReleaseIdsPicker.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseIdsPicker.vue?vue&type=style&index=0&id=a53e3dc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports